import {
    MULTIPLE_WHITESPACE_REGEX,
    TAG_INVALID_CHARACTERS_REGEX,
    TAG_INVALID_CHARACTERS_WITH_SPACES_REGEX,
    TAG_WITH_SINGLE_SPACES_REGEX,
} from "./regexPatterns";

/**
 * Normalizes a tag while preserving each existing form's space policy.
 *
 * @param {*} value Raw tag value.
 * @param {Object} options Normalization options.
 * @param {boolean} options.allowSpaces Whether single spaces are preserved.
 * @returns {string|null} Normalized tag or null when empty.
 */
export function NormalizeTag(value, { allowSpaces = false } = {}) {
    if (value === null || value === undefined || value === "") {
        return null;
    }

    let normalized = String(value).toUpperCase();

    if (allowSpaces) {
        normalized = normalized
            .replace(TAG_INVALID_CHARACTERS_WITH_SPACES_REGEX, "")
            .trim()
            .replace(MULTIPLE_WHITESPACE_REGEX, " ");
    } else {
        normalized = normalized.replace(TAG_INVALID_CHARACTERS_REGEX, "");
    }

    return normalized || null;
}

/**
 * Validates the normalized tag shape used by the multi-tag flow.
 *
 * @param {*} value Tag value.
 * @returns {boolean} True when the tag contains alphanumerics separated by single spaces.
 */
export function IsNormalizedTag(value) {
    return typeof value === "string" && TAG_WITH_SINGLE_SPACES_REGEX.test(value);
}
